import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectors, hooks } from 'farmx-redux-core';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
import { RanchBlockSelect } from './RanchBlockSelect';
import { installState, LABEL_CELSIUS, LABEL_FAHRENHEIT } from '../../../constants';
import { isMobile } from '../../../utils/detectDevice';
import { compareByName } from '../../../helper/common';
import { TemperatureHumiditySummary } from './ListCards/TemperatureHumiditySummary';
import { TemperatureHumiditySensorListItem } from './TemperatureHumiditySensorListItem';

const {
  selectAllSensorsForBlockIdsByType,
  selectUserTemperatureFormat,
  selectSensorLoadingStatus,
} = selectors;

const defaultTemperatureUnit = 'degrees_celsius';

interface Match {
  params: {
    id: string,
  }
}

interface TemperatureHumiditySensorProps {
  match: Match
}

export const TemperatureHumiditySensorList: React.FC<TemperatureHumiditySensorProps> = (
  props: any
) => {
  const { match } = props;
  const blockId = Number(match?.params?.id);
  const { t } = useTranslation();
  const state = useSelector((store) => store);
  const sensorStatus = state.sensorsData.status.entities;

  const [selectedObj, setSelectedObj] = useState({});
  const blockIds = blockId ? [blockId] : hooks?.useRanchBlockSelection()?.blockIds;
  const sensors = useSelector((state) => selectAllSensorsForBlockIdsByType(state, {
    blockIds,
    installState: installState.INSTALLED,
  }));
  const temperatureFormat = useSelector(selectUserTemperatureFormat);
  const TEMPERATURE_LABEL = temperatureFormat === defaultTemperatureUnit
    ? LABEL_CELSIUS : LABEL_FAHRENHEIT;

  const list = (sensors.temperature_humidity || [])?.sort(compareByName);
  const loading = useSelector((store) => selectSensorLoadingStatus(store, list));
  const showList = Boolean(!loading && list.length);

  return (
    <div className="div-default padding-10 page-content device-summary-list">
      <div className="desktop-container">
        <PageHeader
          showBack
          title={t('Temperature Humidity Sensors')}
          toPath="/list"
        />
        {isMobile && (
        <RanchBlockSelect
          selectedObj={selectedObj}
          setSelectedObj={setSelectedObj}
        />
        )}
        <div className="list-container">
          <TemperatureHumiditySummary
            list={list}
          />

          {showList && list.map((s: any) => (
            // Here 'NO_IDENTIFIER' and 'NO_TYPE' added to avoid breaking regression flow
            // when the sensor data doesn't have any one of these
            <Link key={s.identifier} to={`/list/temperature-humidity/${s.type
             || 'NO_TYPE'}/${s.identifier || 'NO_IDENTIFIER'}`}>
              <TemperatureHumiditySensorListItem
                key={s.id}
                details={s}
                status={sensorStatus[`${s.type}/${s.identifier}`]}
                temperatureLabel={TEMPERATURE_LABEL}
              />
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};
